const QuickAction = ({ size = 32, ...rest }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 512 512" {...rest}>
      <path
        id="Shape_74_"
        d="m503.637 224.64-15.991-10.513-15.753-38.076 3.831-18.688c1.263-6.119-.639-12.464-5.06-16.879l-22.357-22.366c-4.416-4.42-10.761-6.319-16.879-5.052l-18.688 3.831-38.076-15.744-10.53-16.034c-3.462-5.202-9.299-8.326-15.548-8.32h-31.573c-6.265-.002-12.114 3.139-15.573 8.363l-10.513 15.991-38.076 15.753-18.688-3.831c-6.119-1.259-12.461.643-16.879 5.06l-22.366 22.357c-4.416 4.418-6.314 10.761-5.052 16.879l2.731 13.295h-56.064c-4.713 0-8.533 3.821-8.533 8.533s3.821 8.533 8.533 8.533h76.8c4.713 0 8.533-3.82 8.533-8.533s-3.821-8.533-8.533-8.533h-3.319l-3.413-16.734c-.105-.5.049-1.02.41-1.382l22.349-22.357c.366-.366.894-.521 1.399-.41l21.239 4.361c1.668.347 3.402.184 4.975-.469l42.923-17.758c1.582-.652 2.93-1.768 3.866-3.2l11.947-18.133c.293-.437.78-.704 1.306-.717h31.573c.522-.005 1.014.247 1.314.674l11.947 18.176c.936 1.433 2.284 2.548 3.866 3.2l42.923 17.758c1.576.644 3.307.808 4.975.469l21.248-4.361c.5-.105 1.02.049 1.382.41l22.357 22.349c.361.369.514.894.41 1.399l-4.361 21.239c-.344 1.668-.18 3.401.469 4.975l17.758 42.923c.652 1.582 1.767 2.93 3.2 3.866l18.133 11.947c.445.295.716.789.725 1.323v31.573c.005.522-.247 1.014-.674 1.314l-18.176 11.947c-1.433.936-2.548 2.284-3.2 3.866l-17.758 42.923c-.649 1.574-.813 3.307-.469 4.975l4.361 21.248c.105.5-.049 1.02-.41 1.382l-22.349 22.357c-.367.365-.894.519-1.399.41l-21.239-4.361c-1.668-.337-3.399-.174-4.975.469l-42.923 17.758c-1.582.652-2.93 1.767-3.866 3.2l-11.947 18.133c-.295.445-.789.716-1.323.725h-31.573c-.51-.006-.987-.257-1.28-.674l-11.947-18.176c-.936-1.433-2.284-2.548-3.866-3.2l-42.923-17.758c-1.574-.649-3.307-.813-4.975-.469l-21.248 4.361c-.5.097-1.016-.056-1.382-.41l-22.357-22.349c-.361-.369-.514-.894-.41-1.399l3.413-16.725h3.294c4.713 0 8.533-3.82 8.533-8.533s-3.821-8.533-8.533-8.533h-76.8c-4.713 0-8.533 3.82-8.533 8.533s3.821 8.533 8.533 8.533h56.064l-2.731 13.303c-1.264 6.12.639 12.464 5.06 16.879l22.357 22.366c4.418 4.417 10.761 6.316 16.879 5.052l18.688-3.831 38.076 15.744 10.539 16.034c3.462 5.202 9.299 8.326 15.548 8.32h31.573c6.265.002 12.114-3.139 15.573-8.363l10.513-15.991 38.076-15.753 18.688 3.831c6.12 1.276 12.47-.628 16.879-5.06l22.366-22.357c4.416-4.418 6.314-10.761 5.052-16.879l-3.831-18.688 15.744-38.076 16.034-10.539c5.2-3.46 8.323-9.293 8.32-15.539v-31.573c.002-6.266-3.139-12.115-8.363-15.574z"
        fill="#afb1ba"
      ></path>
      <path
        id="Shape_73_"
        d="m332.8 366.933c61.267 0 110.933-49.667 110.933-110.933s-49.666-110.933-110.933-110.933-110.933 49.666-110.933 110.933c.07 61.238 49.695 110.863 110.933 110.933zm0-204.8c51.841 0 93.867 42.026 93.867 93.867s-42.026 93.867-93.867 93.867-93.867-42.026-93.867-93.867c.061-51.816 42.051-93.806 93.867-93.867z"
        fill="#afb1ba"
      ></path>
      <path
        id="Shape_72_"
        d="m102.4 170.667h-17.067c-4.713 0-8.533 3.821-8.533 8.533s3.821 8.533 8.533 8.533h17.067c4.713 0 8.533-3.82 8.533-8.533s-3.82-8.533-8.533-8.533z"
        fill="#afb1ba"
      ></path>
      <path
        id="Shape_71_"
        d="m102.4 324.267h-17.067c-4.713 0-8.533 3.82-8.533 8.533s3.821 8.533 8.533 8.533h17.067c4.713 0 8.533-3.82 8.533-8.533s-3.82-8.533-8.533-8.533z"
        fill="#afb1ba"
      ></path>
      <path
        id="Shape_70_"
        d="m204.8 290.133c0-4.713-3.821-8.533-8.533-8.533h-102.4c-4.713 0-8.533 3.821-8.533 8.533 0 4.713 3.821 8.533 8.533 8.533h102.4c4.713.001 8.533-3.82 8.533-8.533z"
        fill="#afb1ba"
      ></path>
      <path
        id="Shape_69_"
        d="m34.133 290.133c0 4.713 3.821 8.533 8.533 8.533h17.067c4.713 0 8.533-3.821 8.533-8.533 0-4.713-3.821-8.533-8.533-8.533h-17.066c-4.713 0-8.534 3.821-8.534 8.533z"
        fill="#afb1ba"
      ></path>
      <path
        id="Shape_68_"
        d="m196.267 213.333h-102.4c-4.713 0-8.533 3.821-8.533 8.533 0 4.713 3.821 8.533 8.533 8.533h102.4c4.713 0 8.533-3.821 8.533-8.533s-3.82-8.533-8.533-8.533z"
        fill="#afb1ba"
      ></path>
      <path
        id="Shape_67_"
        d="m34.133 221.867c0 4.713 3.821 8.533 8.533 8.533h17.067c4.713 0 8.533-3.821 8.533-8.533 0-4.713-3.821-8.533-8.533-8.533h-17.066c-4.713-.001-8.534 3.82-8.534 8.533z"
        fill="#afb1ba"
      ></path>
      <path
        id="Shape_66_"
        d="m187.733 264.533c4.713 0 8.533-3.821 8.533-8.533 0-4.713-3.821-8.533-8.533-8.533h-128c-4.713 0-8.533 3.821-8.533 8.533 0 4.713 3.821 8.533 8.533 8.533z"
        fill="#afb1ba"
      ></path>
      <path
        id="Shape_65_"
        d="m8.533 264.533h17.067c4.713 0 8.533-3.821 8.533-8.533 0-4.713-3.821-8.533-8.533-8.533h-17.067c-4.712 0-8.533 3.82-8.533 8.533s3.821 8.533 8.533 8.533z"
        fill="#afb1ba"
      ></path>
      <path
        id="Shape_64_"
        d="m170.667 145.067c0-4.713-3.821-8.533-8.533-8.533h-102.4c-4.713 0-8.533 3.821-8.533 8.533s3.821 8.533 8.533 8.533h102.4c4.712 0 8.533-3.82 8.533-8.533z"
        fill="#afb1ba"
      ></path>
      <path
        id="Shape_63_"
        d="m162.133 366.933h-102.4c-4.713 0-8.533 3.821-8.533 8.533 0 4.713 3.821 8.533 8.533 8.533h102.4c4.713 0 8.533-3.821 8.533-8.533.001-4.712-3.82-8.533-8.533-8.533z"
        fill="#afb1ba"
      ></path>
      <path
        id="Shape_62_"
        d="m25.6 136.533h-17.067c-4.713 0-8.533 3.821-8.533 8.533s3.821 8.533 8.533 8.533h17.067c4.713 0 8.533-3.82 8.533-8.533s-3.82-8.533-8.533-8.533z"
        fill="#afb1ba"
      ></path>
      <path
        id="Shape_61_"
        d="m8.533 384h17.067c4.713 0 8.533-3.821 8.533-8.533 0-4.713-3.821-8.533-8.533-8.533h-17.067c-4.713 0-8.533 3.821-8.533 8.533 0 4.713 3.821 8.533 8.533 8.533z"
        fill="#afb1ba"
      ></path>
    </svg>
  );
};

export default QuickAction;
